import Button from '@blocks/Button';
import Flex from '@blocks/Flex';
import Form from '@blocks/Form';
import Grid from '@blocks/Grid';
import Sidepanel from "@blocks/Sidepanel";
import { useSidepanelContext } from '@contexts/sidepanel';
import { capitalize, notify, confirmation } from '@helpers';
import React from 'react';

export default function ResourceEditSidepanel<R extends ObjectWithId>({ model, resource, label, controller, form: FormInputs }: Props<R>) {
    const sidepanel = useSidepanelContext()

    const handleDelete = async () => {
        const confirmed = await confirmation(`Are you sure you want to delete the ${label}?`)
        if (!confirmed) return

        sidepanel.close()
        await controller.destroy(model.id)

        resource.setData(old => old?.filter(item => item.id !== model.id))
        notify(`The ${label} was deleted.`)
    }
    
    const handleSubmit = async (data: FormData) => {
        sidepanel.close()
        return controller.update(model.id, data)
    }

    const handleSuccess = (response: R) => {
        resource.setData(old => old?.map(item => {
            if (item.id == response.id)
                return response
            
            return item
        }))

        notify(`The ${label} was updated.`)
    }

    return (
        <Sidepanel heading={`Edit: ${capitalize(label)}`}>
            <Form method="patch" handleSubmit={handleSubmit} handleSuccess={handleSuccess}>
                <Grid>
                    <FormInputs model={model} />
                    <Grid gap="20px">
                        <Button element="submit">Save</Button>
                        <Flex justifyContent="center">
                            <Button type="tertiary" onClick={handleDelete}>Delete</Button>
                        </Flex>
                    </Grid>
                </Grid>
            </Form>
        </Sidepanel>
    )
}

interface Props<R extends object> extends Modules.Resource.SidepanelOptions<R> {
    model: R
}